import {
  useContext, useEffect, useRef, useState,
} from 'react';
import { Route, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
  Badge,
  Button, Container, Form, ListGroup, Offcanvas, OverlayTrigger, Row,
  Tooltip,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { ContextPtfa } from '../../utils/ContextPtfa';
import TitlePage from '../../components/GestisciUtenti/TitoloPagina';
import ModaleConferma from '../../components/modali/ModaleConferma';
import history from '../../utils/history';
import { Context } from '../../utils/Context';
import PtfaService from '../../services/ptfaService';
import './index.css';
import themeColors from '../../utils/contants/theme-colors';
import { getItem, removeItem } from '../../utils/storage';
import ModaleCentroVerticale from '../../components/modali/ModaleCentroVerticale';
import Table from '../../components/Shared/Table';
import fieldsPiani from './fieldsTable';
import EmptyState from '../../components/EmptyState';

function PtfaLayout({ component: Component, ...rest }) {
  const visualizzazioneAmministrazionePTFA = getItem('visualizzazioneAmministrazionePTFA');
  const [context, setContext] = useContext(Context);
  const [contextPtfa, setContextPtfa] = useContext(ContextPtfa);
  const { sequ_k_comparto } = JSON.parse(getItem('compartoSelected'));
  const { idPtfa } = useParams();
  const { pathname } = history.location;
  const [modalIndietro, setModalIndietro] = useState(false);
  const [showMenu, setShowMenu] = useState(true);
  const [showAttiva, setShowAttiva] = useState(false);
  const [disabledConsolida, setDisabledConsolida] = useState(true);
  const [isCompilazione, setIsCompilazione] = useState(contextPtfa.isCompilazione);
  const [modalShow, setModalShow] = useState(false);
  const [modalAvvia, setModalAvvia] = useState(false);
  const [ptfaPianiConsolidatiList, setPtfaPianiConsolidatiList] = useState([]);
  const [quadroSelected, setQuadroSelected] = useState({});
  const [renderKey, setRenderKey] = useState(0);
  // Se sono un'Amministrazione Centrale devo filtrare il menu di compilazione
  // per verificare se sono un'Amministrazione con o senza autorizzazione
  // Comporta la presenza o meno di alcuni quadri del reclutamento autorizzato
  const menuCompilazione = sequ_k_comparto === 3
    ? contextPtfa?.menu?.compilazione.filter(
      (quadro) => quadro.nonVisibile === false,
    )
    : contextPtfa?.menu?.compilazione;
  const prevSequRef = useRef();

  // Function collegata al servizio per modificare il piano
  async function modificaPianoAmministrazione(isCompila = false, isConsolida = false) {
    const newState = {
      ...contextPtfa,
      stato: isConsolida ? 2 : contextPtfa.stato,
      isCompilazione: isCompila || contextPtfa?.isCompilazione,
    };
    if (contextPtfa.isLastVersion && contextPtfa.version > 1) {
      delete newState.data_consolidamento;
      delete newState.data_chiusura;
    }
    if (isConsolida) {
      newState.data_consolidamento = new Date();
    }
    if (!contextPtfa.oneri_medi?.dirigenti && isCompila) {
      const new_oneri_medi = Object.keys(contextPtfa.oneri_medi.aree)
        .reduce(
          (acc, key) => {
            if (contextPtfa.oneri_medi.aree[key].some((el) => el.flag_dirigente === true)) {
              acc.dirigenti = contextPtfa.oneri_medi.aree[key].map(
                (el) => ({
                  ...el,
                  fascia: el.desc_area,
                }),
              );
            } else {
              acc.aree = {
                ...acc.aree,
                [key]: contextPtfa.oneri_medi.aree[key],
              };
            }
            return acc;
          },
          {},
        );
      newState.oneri_medi = { ...newState.oneri_medi, ...new_oneri_medi };
      setContextPtfa((prevState) => ({
        ...prevState,
        oneri_medi: newState.oneri_medi,
      }));
    }
    PtfaService.modificaPianoAmministrazione(
      newState,
      idPtfa,
    )
      .then((res) => {
        setContext(() => ({
          ...context,
          openConferma: true,
          testo: res.message,
        }));
        if (isCompila) {
          history.push(`/area-riservata/ptfa/${idPtfa}/${sequ_k_comparto}/dotazione-organica-smps`);
        }
        if (isConsolida) {
          history.push('/area-riservata/ptfa');
        }
      })
      .catch((err) => {
        setContext(() => ({
          ...context,
          open: true,
          testoErrore: err?.data?.message || 'Errore',
          statusCode: err?.status,
        }));
      });
  }

  // Function collegata al servizio per ottenere la lista dei piani PTFA
  async function getPtfaPianiConsolidati(offset, limit, filters) {
    try {
      const filterSession = filters;
      const response = await PtfaService
        .getPiano(limit, offset, { ...filterSession, comparto: sequ_k_comparto });
      const pianiConsolidati = response.rows.filter(
        (piano) => piano.pianiAmministrazione.length > 0
         && piano.pianiAmministrazione[0].stato === 2,
      );
      setPtfaPianiConsolidatiList(pianiConsolidati);
    } catch (err) {
      setContext(() => ({
        ...context,
        open: true,
        testoErrore: err?.data?.message || 'Errore',
        statusCode: err?.status,
      }));
    }
  }

  // function che gestisce la copia del piano consolidato
  const handleCopiaPianoConsolidato = (piano) => {
    if (pathname.endsWith('/dotazione-organica-smps')) {
      const menuUpdate = contextPtfa.menu.compilazione.map(
        (el) => {
          if (el.id === '1') {
            return ({
              ...el,
              compilato: true,
            });
          }
          if (el.id === '2') {
            return ({
              ...el,
              compilato: false,
            });
          }
          return el;
        },
      );
      setContextPtfa((prevState) => ({
        ...prevState,
        compilazione: {
          ...prevState.compilazione,
          1: piano.pianiAmministrazione[0].compilazione[1],
        },
        menu: {
          ...prevState.menu,
          compilazione: menuUpdate,
        },
      }));
    }
    if (pathname.endsWith('/censimento-personale-indeterminato')) {
      const menuUpdate = contextPtfa.menu.compilazione.map(
        (el) => {
          if (el.id === '3_P1') {
            return ({
              ...el,
              compilato: true,
            });
          }
          if (el.id === '7') {
            return ({
              ...el,
              compilato: false,
            });
          }
          return el;
        },
      );
      setContextPtfa((prevState) => ({
        ...prevState,
        compilazione: {
          ...prevState.compilazione,
          '3_P1': piano.pianiAmministrazione[0].compilazione['3_P1'],
        },
        menu: {
          ...prevState.menu,
          compilazione: menuUpdate,
        },
      }));
    }
    setRenderKey((prevState) => prevState + 1);
    setModalShow(false);
  };

  // function che gestisce il colore del badge
  const handleBadgeColor = (option) => {
    const isSecondary = option?.dipendenteDa?.some((el) => !menuCompilazione
      .find((el2) => el2.id === el)?.compilato);
    if (isSecondary && option.compilabile) {
      return 'grey';
    }
    if (!option.compilato && option.compilabile) {
      return 'danger';
    }
    if (option.compilato && option.compilabile) {
      return 'success';
    }
    if (['3_P2', '3_P3', '3_P4', '3_P5', '3_P6'].includes(option.id) && !option.compilabile) {
      return 'warning';
    }
    return '';
  };

  // Function per gestire il comportamento del bottone di consolidamento
  const handleConsolida = () => {
    if (isCompilazione) {
      modificaPianoAmministrazione(false, true);
    } else {
      setIsCompilazione(true);
      setContextPtfa((prevState) => ({
        ...prevState,
        isCompilazione: true,
      }));
      modificaPianoAmministrazione(true);
    }
    setModalAvvia(false);
  };

  // Function per gestire il comportamento della conferma per abilita/disabilita quadro
  const handleSwitch = () => {
    let compilabileTmp;
    let slugTmp;
    setContextPtfa((prevState) => {
      const menuUpdate = prevState.menu.compilazione.map(
        (el) => {
          if (el.id === quadroSelected.id) {
            compilabileTmp = !el.compilabile;
            slugTmp = el.slug;
            return ({
              ...el,
              compilabile: compilabileTmp,
            });
          }
          return el;
        },
      );
      return ({
        ...prevState,
        menu: {
          ...prevState.menu,
          compilazione: menuUpdate,
        },
      });
    });
    if (!compilabileTmp && pathname.endsWith(slugTmp)) {
      history.push(`/area-riservata/ptfa/${idPtfa}/${sequ_k_comparto}/dotazione-organica-smps`);
    }
    setShowAttiva(false);
  };

  // Function collegata al bottone di salvataggio intermedio del piano
  const onSave = () => {
    modificaPianoAmministrazione();
  };

  const onIndietro = () => {
    removeItem('visualizzazioneAmministrazionePTFA');
    if (!visualizzazioneAmministrazionePTFA && contextPtfa.stato !== 2) {
      setModalIndietro(true);
    } else {
      const path = (contextPtfa.stato === 2 && !visualizzazioneAmministrazionePTFA) ? '' : `/${contextPtfa.id_piano}/visualizza-piani-amministrazione`;
      history.push(
        `/area-riservata/ptfa${path}`,
      );
    }
  };

  // Function per abilitare il tasto di consolidamento del piano
  const checkDisabledConsolida = () => {
    if (menuCompilazione
      ?.filter((quadro) => quadro.compilabile === true)
      .every(
        (el) => el.compilato === true,
      )) {
      setDisabledConsolida(false);
    }
  };

  async function getPianoAmmin() {
    try {
      const response = await PtfaService.getPianoAmminById(idPtfa);

      setContextPtfa((prev) => {
        // se esiste già, non sovrascriverla
        if (prev && Object.keys(prev).length > 0) { return prev; }

        // altrimenti carica dal DB
        return response;
      });
      setIsCompilazione(response.isCompilazione);
      return response;
    } catch (err) {
      setContext(() => ({
        ...context,
        open: true,
        testoErrore: err?.data?.message || 'Errore',
        statusCode: err?.status,
      }));
      return {};
    }
  }

  // useEffect per gestire il tasto di consolidamento
  useEffect(() => {
    checkDisabledConsolida();
  }, [contextPtfa]);

  // useEffect per controllare se esiste il contextPtfa
  useEffect(() => {
    if (Object.entries(contextPtfa).length === 0) {
      const pianoAmministrazione = async () => {
        const ptfaAmmin = await getPianoAmmin();
        const paginaCorrente = ptfaAmmin.menu?.compilazione
          .find((el) => pathname.endsWith(el.slug));
        const isDisabled = paginaCorrente?.dipendenteDa
          ?.some((el) => !ptfaAmmin?.menu?.compilazione.find((el2) => el2.id === el).compilato);

        if (isDisabled) history.push(`/area-riservata/ptfa/${idPtfa}/${sequ_k_comparto}/dotazione-organica-smps`);
      };
      pianoAmministrazione();
    }
    getPtfaPianiConsolidati(
      0,
      200,
      {},
    );
  }, []);

  // useEffect per controllare il cambio comparto
  useEffect(() => {
    if (prevSequRef.current !== undefined) {
      if (prevSequRef.current !== sequ_k_comparto) {
        removeItem('visualizzazioneAmministrazionePTFA');
        history.push('/area-riservata/ptfa');
      }
    }
    prevSequRef.current = sequ_k_comparto;
  }, [sequ_k_comparto]);

  // useEffect per pulire il context per la distruzione della pagina/componente
  useEffect(() => () => {
    setContextPtfa({});
  }, []);

  return (
    Object.entries(contextPtfa).length > 0 && (
      <Route
        {...rest}
        render={(matchProps) => (
          <>
            <Container fluid>
              <Row xs={12}>
                <TitlePage
                  title={`PTFA - ${contextPtfa.desc_denominazione}`}
                  subtitle={`Utilizza il menu a destra per navigare tra i quadri da ${visualizzazioneAmministrazionePTFA ? 'visualizzare' : 'compilare'}.`}
                  showMenuPtfa
                  functionMenuPtfa={() => setShowMenu(true)}
                  showIndietro
                  functionIndietro={onIndietro}
                  showSave={contextPtfa.stato !== 2}
                  functionSave={() => onSave()}
                  showConsolida={!isCompilazione && (pathname.endsWith('/configurazione-turnover') || sequ_k_comparto === 1 || sequ_k_comparto === 2)}
                  titleConsolida={isCompilazione ? 'CONSOLIDA' : 'PASSA ALLA COMPILAZIONE'}
                  functionConsolida={() => setModalAvvia(true)}
                  // Si commenta il consolidamento per richiesta del cliente
                  showConsolidaTooltip={isCompilazione && contextPtfa.stato !== 2}
                  titleConsolidaTooltip={`Il piano PTFA ${contextPtfa.desc_denominazione}
                  potrà essere consolidato quando tutti i quadri verranno compilati.`}
                  disabledConsolidaTooltip={disabledConsolida}
                  functionConsolidaTooltip={() => setModalAvvia(true)}
                  showGeneral={(pathname.endsWith('/dotazione-organica-smps')
                    || pathname.endsWith('/censimento-personale-indeterminato'))
                    && contextPtfa.stato !== 2}
                  functionGeneral={() => setModalShow(true)}
                  titleGeneral="COPIA DA ANNO PRECEDENTE"
                  iconGeneral="copy"
                  variantGeneral="primary"
                />
              </Row>
              <Row xs={12}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Component key={renderKey} {...matchProps} />
                </div>
              </Row>
              <ModaleConferma
                labelBottone="Conferma"
                coloreAzione="primary"
                title="Sei sicuro di procedere?"
                body={(
                  <p>
                    L&apos;operazione ti farà uscire dalla scheda corrente.
                    Se si procede, i dati inseriti non verranno salvati.
                    Procedere prima con il salvataggio dei dati e poi confermare.
                  </p>
              )}
                show={modalIndietro}
                handleClose={() => setModalIndietro(false)}
                handleOk={() => {
                  history.push('/area-riservata/ptfa');
                }}
              />
              <Offcanvas
                show={showMenu}
                onHide={() => setShowMenu(false)}
                placement="end"
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>Menu PTFA</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <div className="arrow-on-sidebar rounded-start">
                    <div className="blue-centered-div" />
                    <Button
                      variant="link"
                      className="rotate-180"
                      onClick={() => setShowMenu(false)}
                    >
                      <FontAwesomeIcon
                        title="Apri/Chiudi menu gestione PTFA"
                        aria-hidden="true"
                        color="outline-primary"
                        icon={['fas', 'circle-chevron-right']}
                        style={{
                          fontSize: '3rem',
                          color: 'white',
                          borderRadius: '100%',
                          backgroundColor: 'transparent',
                        }}
                      />
                    </Button>
                  </div>
                  <div style={{ zIndex: '1051', position: 'relative' }}>
                    <h3>CONFIGURAZIONE</h3>
                    <ListGroup>
                      {contextPtfa?.menu?.configurazione.map(
                        (el) => (
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-center"
                          // configurazione resta attiva se sono consolidato
                            disabled={isCompilazione && contextPtfa.stato !== 2}
                            variant="light"
                            active={pathname.endsWith(el.slug)}
                            action={!pathname.endsWith(el.slug)}
                          >
                            <div className="ms-2 me-auto">
                              <Link
                                style={
                                isCompilazione && contextPtfa.stato !== 2
                                  ? {
                                    pointerEvents: 'none',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                    color: themeColors.dark,
                                  }
                                  : {}
                              }
                                to={`/area-riservata/ptfa/${idPtfa}${el.slug}`}
                                title={el.nome}
                              >
                                {el.nome}
                              </Link>
                            </div>
                          </ListGroup.Item>
                        ),
                      )}
                    </ListGroup>
                    <br />
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                    >
                      <h3>
                        COMPILAZIONE
                        {' '}
                      </h3>
                      {contextPtfa.stato !== 2 && ( // mostro se non sono consolidato
                      <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={(
                          <Tooltip id="button-tooltip" className="custom-wide-tooltip">
                            <ul style={{
                              paddingLeft: '1rem', margin: 0, textAlign: 'left', marginTop: '0.5rem',
                            }}
                            >
                              <Badge
                                bg="danger"
                                pill={false}
                              >
                                {' '}
                              </Badge>
                              {' '}
                              Quadro compilabile ma non compilato
                            </ul>
                            <ul style={{
                              paddingLeft: '1rem', margin: 0, textAlign: 'left',
                            }}
                            >
                              <Badge
                                bg="success"
                                pill={false}
                              >
                                {' '}
                              </Badge>
                              {' '}
                              Quadro compilato
                            </ul>
                            <ul style={{
                              paddingLeft: '1rem', margin: 0, textAlign: 'left',
                            }}
                            >
                              <Badge
                                bg="warning"
                                pill={false}
                              >
                                {' '}
                              </Badge>
                              {' '}
                              Quadro non ancora abilitato
                            </ul>
                            <ul style={{
                              paddingLeft: '1rem', margin: 0, textAlign: 'left', marginBottom: '0.5rem',
                            }}
                            >
                              <Badge
                                bg="grey"
                                pill={false}
                              >
                                {' '}
                              </Badge>
                              {' '}
                              Quadro abilitato e dipendente da altri quadri
                            </ul>
                          </Tooltip>
                        )}
                      >
                        <FontAwesomeIcon
                          aria-hidden="true"
                          icon={['fas', 'circle-info']}
                          size="xl"
                          title="Legenda colori"
                          style={{ color: themeColors.primary, marginBottom: '8px' }}
                        />
                      </OverlayTrigger>
                      )}
                    </div>
                    <ListGroup>
                      {menuCompilazione.map(
                        (el) => (
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-center"
                            disabled={!isCompilazione}
                            variant="light"
                            active={pathname.endsWith(el.slug)}
                            action={!pathname.endsWith(el.slug)}
                          >
                            <div className="ms-2 me-auto">
                              <Link
                                to={(['3_P2', '3_P3', '3_P4', '3_P5', '3_P6'].includes(el.id) && !el.compilabile) ? '' : `/area-riservata/ptfa/${idPtfa}/${sequ_k_comparto}${el.slug}`}
                                title={el.nome}
                                style={(!isCompilazione
                                || (el.compilabile && el?.dipendenteDa?.some(
                                  (el) => !menuCompilazione
                                    .find((el2) => el2.id === el)?.compilato,
                                ))) ? {
                                    pointerEvents: 'none',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                    color: themeColors.dark,
                                  } : {
                                    color: (['3_P2', '3_P3', '3_P4', '3_P5', '3_P6'].includes(el.id) && !el.compilabile) ? themeColors.dark : '',
                                    pointerEvents: (['3_P2', '3_P3', '3_P4', '3_P5', '3_P6'].includes(el.id) && !el.compilabile) ? 'none' : '',
                                  }}
                              >
                                {el.nome}
                              </Link>
                            </div>
                            {contextPtfa.stato !== 2 && ( // mostro se non sono consolidato
                            <>
                              {['3_P2', '3_P3', '3_P4', '3_P5', '3_P6'].includes(el.id) && (
                              <Form.Check
                                type="switch"
                                className="fixed-size-switch"
                                onChange={() => {
                                  setQuadroSelected(el);
                                  setShowAttiva(true);
                                }}
                                checked={el.compilabile}
                                disabled={!contextPtfa.isCompilazione}
                              />
                              )}

                              <Badge
                                bg={handleBadgeColor(el)}
                                pill={false}
                                hidden={!isCompilazione}
                              >
                                {' '}
                              </Badge>
                            </>
                            )}

                          </ListGroup.Item>
                        ),
                      )}
                    </ListGroup>
                    <br />
                    <h3>REPORTS</h3>
                    <ListGroup>
                      {contextPtfa?.menu?.reports.map(
                        (el) => (
                          <ListGroup.Item
                            as="li"
                            className="d-flex justify-content-between align-items-center"
                            disabled={!isCompilazione}
                            variant="light"
                            active={pathname.endsWith(el.slug)}
                            action={!pathname.endsWith(el.slug)}
                          >
                            <div className="ms-2 me-auto">
                              <Link
                                to={`/area-riservata/ptfa/${idPtfa}/${sequ_k_comparto}${el.slug}`}
                                title={el.nome}
                                style={(!isCompilazione)
                                  ? {
                                    pointerEvents: 'none',
                                    opacity: 0.5,
                                    cursor: 'not-allowed',
                                    color: themeColors.dark,
                                  } : {}}
                              >
                                {el.nome}
                              </Link>
                            </div>
                          </ListGroup.Item>
                        ),
                      )}
                    </ListGroup>
                  </div>
                </Offcanvas.Body>
              </Offcanvas>
            </Container>
            <ModaleConferma
              title={`Quadro - ${quadroSelected.nome}`}
              body={(
                <p>
                  Il quadro selezionato
                  {' '}
                  {quadroSelected.compilabile ? '' : 'non'}
                  {' '}
                  è stato abilitato nella fase di compilazione
                  del questionario.
                  <br />
                  Se desideri
                  {' '}
                  {quadroSelected.compilabile ? 'disabilitarlo' : 'abilitarlo'}
                  , clicca il bottone
                  {' '}
                  {quadroSelected.compilabile ? 'DISABILITA' : 'ABILITA'}
                  {' '}
                  e procedi con la compilazione.
                </p>
            )}
              show={showAttiva}
              handleClose={() => setShowAttiva(false)}
              handleOk={() => handleSwitch()}
              labelBottone={quadroSelected.compilabile ? 'DISABILITA' : 'ABILITA'}
              coloreAzione="primary"
            />
            <ModaleCentroVerticale
              modalTitle="Copia da un piano consolidato"
              modalBody={ptfaPianiConsolidatiList.length > 0 ? (
                <Table
                  data={ptfaPianiConsolidatiList}
                  fields={fieldsPiani(handleCopiaPianoConsolidato)}
                  keyField="_id"
                />
              ) : (
                <EmptyState
                  subtitle="Non sono stati trovati piani consolidati"
                />
              )}
              disabledConfirm
              buttonType="submit"
              show={modalShow}
              onClose={() => setModalShow(false)}
            />
            <ModaleConferma
              labelBottone="Conferma"
              coloreAzione="primary"
              title={`${isCompilazione ? 'Consolida' : 'Compila'} Piano`}
              body={isCompilazione ? (
                <p>
                  Sei sicuro di voler consolidare il piano
                  {' '}
                  {contextPtfa.desc_denominazione}
                  ? L&apos;operazione
                  {' '}
                  <strong>non</strong>
                  {' '}
                  e&apos; reversibile.
                </p>
              ) : (
                <p>
                  Vuoi procedere con la compilazione del piano
                  {' '}
                  {contextPtfa.desc_denominazione}
                  ? L&apos;operazione
                  {' '}
                  <strong>non</strong>
                  {' '}
                  e&apos; reversibile.
                </p>
              )}
              show={modalAvvia}
              handleClose={() => setModalAvvia(false)}
              handleOk={() => handleConsolida()}
            />
          </>
        )}
      />
    )
  );
}

export default PtfaLayout;
